import React, { useEffect, useState } from "react";
import { motion, useMotionValue, useTransform } from "framer-motion";
import waraeru from "../data/png/waraeru.png";

const WaraeruTalk = () => {
  const [phase, setPhase] = useState("thinking");
  const [visibleText, setVisibleText] = useState("");
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isJumping, setIsJumping] = useState(false);

  const rawText = "こんにちは〜！いまどんな気分〜？";
  const fullText = rawText.trim(); // ← trim() でスペースや改行を削除

  const y = useMotionValue(0);

  const shadowScale = useTransform(y, [-20, 0], [0.5, 1.0]); // 高い → 小さい
  const shadowOpacity = useTransform(y, [-20, 0], [0.1, 0.3]); // 高い → 薄い

  //   useEffect(() => {
  //     // しゃべり終わったあとにだけジャンプインターバルを開始する
  //     if (!isSpeaking && phase === "talking") {
  //       const jumpInterval = setInterval(() => {
  //         setIsJumping(true);
  //         setTimeout(() => setIsJumping(false), 400);
  //       }, 4000);

  //       // cleanup で次のしゃべり時に干渉しないようにする
  //       return () => clearInterval(jumpInterval);
  //     }
  //   }, [isSpeaking, phase]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPhase("talking");
    }, 1500); // 1.5秒考えてからしゃべる
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isSpeaking && phase === "talking") {
      const timeout = setTimeout(() => {
        const jumpInterval = setInterval(() => {
          setIsJumping(true);
          setTimeout(() => setIsJumping(false), 400);
        }, 4000);
        // スコープ外の return で clearInterval する
      }, 1000);
      return () => clearTimeout(timeout);
    }
  }, [isSpeaking, phase]);

  useEffect(() => {
    if (phase === "talking") {
      const chars = Array.from(fullText);
      let i = 0;
      setVisibleText(""); // ← ここでちゃんと初期化
      setIsSpeaking(true); // 🟢 話し始めたら speaking = true
      const interval = setInterval(() => {
        if (i >= chars.length) {
          clearInterval(interval);
          setIsSpeaking(false); // 🛑 終わったら speaking = false
          return;
        }
        const nextChar = chars[i];
        if (nextChar !== undefined) {
          setVisibleText((prev) => prev + nextChar);
        }
        i++;
      }, 80);
      return () => clearInterval(interval);
    }
  }, [phase]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "240px",
      }}
    >
      {/* 中央寄せ */}
      <div
        style={{
          position: "absolute",
          top: "40px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        {/* わらえる君と影を包む */}
        <div style={{ position: "relative", width: 120, height: 120 }}>
          <motion.img
            src={waraeru}
            style={{ width: 120, y }}
            alt="わらえる君"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{
              opacity: 1,
              scale: 1,
              y: isJumping ? [-5, -20, 0] : 0,
              rotate: isSpeaking ? [0, -3, 3, -3, 0] : 0,
              scaleY: isSpeaking ? [1, 0.97, 1.03, 0.97, 1] : 1,
            }}
            transition={{
              duration: isJumping ? 0.4 : 1,
              ease: "easeInOut",
              repeat: isSpeaking ? Infinity : 0,
              repeatType: "loop",
            }}
          />

          {/* 👇影を下にabsolute配置！ */}
          <motion.div
            style={{
              position: "absolute",
              bottom: 18,
              left: "30%",
              transform: "translateX(-50%)",
              width: 60,
              height: 12,
              borderRadius: "50%",
              background: "rgba(0, 0, 0, 1)",
              scale: shadowScale,
              opacity: shadowOpacity,
              filter: "blur(2px)",
              zIndex: -1,
            }}
          />
        </div>

        <div
          style={{
            background: "#fff",
            borderRadius: "16px",
            padding: "12px 16px",
            marginLeft: "12px",
            width: "220px",
            fontSize: "16px",
            color: "#333",
            fontFamily: "'Mochiy Pop One', sans-serif",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            wordBreak: "break-word",
            lineHeight: 1.6,
            position: "relative",
          }}
        >
          {/* セリフ */}
          {phase === "thinking" ? "・・・・・・・・・・・・・・" : visibleText}

          {/* 三角マーカー */}
          <div
            style={{
              position: "absolute",
              left: "-12px",
              top: "20px",
              width: 0,
              height: 0,
              borderTop: "8px solid transparent",
              borderBottom: "8px solid transparent",
              borderRight: "12px solid #fff",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default WaraeruTalk;
